import { render, staticRenderFns } from "./LogoTextBlock.vue?vue&type=template&id=5afc7838&scoped=true&"
import script from "./LogoTextBlock.vue?vue&type=script&lang=ts&"
export * from "./LogoTextBlock.vue?vue&type=script&lang=ts&"
import style0 from "./LogoTextBlock.vue?vue&type=style&index=0&id=5afc7838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afc7838",
  null
  
)

export default component.exports